import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-资产调拨电子流",
  "use": "icon-资产调拨电子流-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-资产调拨电子流\"><path fill=\"#333333\" d=\"M382.342982 280.669091l315.270982-88.147782 57.362618 203.813236-318.073018 85.8112-54.560582-201.476654z m56.441018 237.856582l478.040436-135.717237 59.233746 196.8128-475.247709 132.459055-62.026473-193.554618z m130.113164 239.262254l391.298327-106.337745L977.454545 705.079855 582.888727 811.4176l-13.991563-53.629673zM46.545455 75.924945h114.734545V91.322182H276.014545l145.501091 572.7232-53.629672 18.189963-139.450182-546.136436-62.966691-0.930909-1.396364 15.387927L46.545455 148.6848V75.924945z m472.445672 756.484655c0 63.8976-51.767855 115.665455-115.665454 115.665455-63.888291 0-115.665455-51.767855-115.665455-115.665455 0-63.8976 51.767855-115.665455 115.665455-115.665455 63.906909 0 115.665455 51.767855 115.665454 115.665455\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/资产调拨电子流.svg
// module id = OFOk
// module chunks = 183